import { Component, OnInit } from '@angular/core';
import { Apollo, gql } from 'apollo-angular';
import { catchError, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { Settings } from './settings.interface';

const query = gql`
    query Query($name: String!) {
        webAccountInfo(name: $name) {
            logo
            headerTitle
            headerSubTitle
            name
            themeColor
            isActive
            customerID
            creditCardProcessingMethod
            stripeAccountID
        }
    }
`;

@Component({
    selector: 'ols-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
    settings: Settings;
    isLoading = true;
    isFailedLogo = false;
    isLogoReady = false;

    constructor(private apollo: Apollo) {}

    ngOnInit() {
        this.apollo
            .query({
                query,
            })
            .pipe(
                tap((response: any) => {
                    if (response?.data?.webAccountInfo) {
                        this.settings = response?.data?.webAccountInfo;
                    }
                    this.isLoading = false;
                })
            )
            .pipe(
                catchError((_err) => {
                    this.isLoading = false;
                    return of(null);
                })
            )
            .subscribe();
    }

    failLogo() {
        this.isFailedLogo = true;
    }

    logoIsReady() {
        this.isLogoReady = true;
    }
}
